import { ProviderInformationCollectionDetails } from "./provider-information-collection-details.model";
import { MinimalProvider } from "./minimal-provider.model";
import { ProviderDataReview } from "./provider-data-review.model";
import { ProviderSpecialistDetectionLlmResult } from './provider-specialist-detection-llm-result.model';

export class Provider extends MinimalProvider {
  first: string;
  last: string;
  credentials: string;
  captureClientNames: string[];
  captureClientStates: string[];
  affiliatedClientNames: string[];
  specialties: string[];
  eligibleEncountersCount: number;
  ineligibleEncountersCount: number;
  confirmed: boolean;
  updatedAt: string;
  note: string;
  informationCollectionDetails?: ProviderInformationCollectionDetails;
  providerDataReviews: ProviderDataReview[];
  llmSpecialistDetectionResults: ProviderSpecialistDetectionLlmResult[];
}
